import { create } from 'zustand'
import { TrainingsStoreType } from './storeTypes'

const useTrainingsAdminStore = create<TrainingsStoreType.State>((set) => {
	return {
		dataLoadingStatus: 'loading',
		trainingsAdmin: undefined as any,
		rawTrainings: undefined as any,
		selectedLang: 'ru',
		searchStr: null,
		selectedType: 'big',

		/** Установщик новых значений корневого объекта. */
		updateStore(obj) {
			return set((state) => {
				return obj
			})
		},
		setSelectedType(type) {
			set({ selectedType: type })
		},
	}
})

export default useTrainingsAdminStore
